/**
 * @generated SignedSource<<21b7d4e47056663052a0685d7f0e907d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentDescriptionSectionFragment$data = {
  readonly id: string;
  readonly richEditorDescriptionContent: string | null;
  readonly type: ContentType;
  readonly " $fragmentSpreads": FragmentRefs<"DiscoEditorMentionsFragment">;
  readonly " $fragmentType": "ContentDescriptionSectionFragment";
};
export type ContentDescriptionSectionFragment$key = {
  readonly " $data"?: ContentDescriptionSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentDescriptionSectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentDescriptionSectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "richEditorDescriptionContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiscoEditorMentionsFragment"
    }
  ],
  "type": "Content",
  "abstractKey": null
};

(node as any).hash = "82f56b53b73a6d8e839d0df1cb73babf";

export default node;
